import React, { useEffect, useMemo, useState } from "react";
import cx from "classnames";

import { Hooks, Util } from "@xt/xtbase";
const { useTranslation, Trans } = Hooks;
const { getUrl } = Util;

import styles from "./index.module.scss";

// interface Props extends React.HTMLAttributes<HTMLDivElement> {
//   label?: string;
// }

const AppDivToLogin: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  const t = useTranslation();

  const [urlObj, setUrlObj] = useState({ login: "", register: "" });
  useEffect(() => {
    const query = "?backurl=" + encodeURIComponent(location.href);
    setUrlObj({
      login: getUrl("/accounts/login" + query),
      register: getUrl("/accounts/register" + query),
    });
  }, []);
  
  return (
    <div className={cx(styles.main, className)} {...rest}>
      <span>
        <Trans
          i18nKey="user.toLogin"
          components={{
            1: (
              <a key="1" style={{ color: "#45BF76" }} href={urlObj.login}>
                {t("app.login")}
              </a>
            ),
            2: (
              <a key="2" style={{ color: "#45BF76" }} href={urlObj.register}>
                {t("app.register")}
              </a>
            ),
          }}
        ></Trans>
      </span>
    </div>
  );
};

export default AppDivToLogin;
